import { useMutation, useQueryClient } from 'react-query';
import { subscriptionService } from 'services';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { displayNotification } from 'utils';
import { useI18n } from 'contexts/i18n';

export const useUpdateSubscriptionPayment = () => {
  const queryClient = useQueryClient();
  const i18n = useI18n();
  return useMutation(
    ({
      subscriptionId,
      cardToken,
    }: {
      subscriptionId: number;
      cardToken: string | null;
    }) => {
      return subscriptionService.updateSubscriptionPayment(
        subscriptionId,
        cardToken
      );
    },
    {
      onSuccess: (data, variables, context) => {
        displayNotification(i18n['Subscription payment successfully updated.']);
        queryClient.invalidateQueries([
          ServerStateKeysEnum.subscriptionHistory,
        ]);
      },
      onError: () => {
        displayNotification(i18n['Failed to update subscription payment!'], 'danger');
      },
    }
  );
};
